const state = {
  queryPara: {
    keyWord: "",
    specify: "",
    queryType: "poiSearch",
    start: 0,
    count: 10
  },
  inputKeyWord: {
    keyWord: "",
    isFuzzyQuery: true
  },
  nearbyQueryDistance: 500,
  isSearchLoading: false,
  searchListBln: false,
  searchListBlnStatistics: false,
  drivePathPara: {
    startPoint: "",
    endPoint: "",
    midPoint: "",
    startInitial: "",
    endInitial: "",
    type: ""
  },
  trafficPathPara: {
    startPoint: "",
    endPoint: "",
    startInitial: "",
    endInitial: "",
    type: ""
  },
  trafficStation: {
    uuid: ""
  },
  inverseGeocoderPara: {
    point: ""
  },
  startPara: {
    startInitial: "",
    startPoint: ""
  },
  endPara: {
    endInitial: "",
    endPoint: ""
  },
  currentDistrict: null
};

const mutations = {
  setCurrentDis(state, type) {
    state.currentDistrict = type;
  },
  setListBln(state, type) {
    state.searchListBln = type;
  },
  setListBlnStatistics(state, type) {
    state.searchListBlnStatistics = type;
  },
  setQueryPara(state, queryPara) {
    state.queryPara = queryPara;
  },
  setInputKeyWord(state, inputKeyWord) {
    state.inputKeyWord = inputKeyWord;
  },
  setNearbyQueryDistance(state, nearbyQueryDistance) {
    state.nearbyQueryDistance = nearbyQueryDistance;
  },
  setIsSearchLoading(state, isSearchLoading) {
    state.isSearchLoading = isSearchLoading;
  },
  setQueryDrivePath(state, drivePathPara) {
    state.drivePathPara = drivePathPara;
  },
  setQueryTrafficPath(state, trafficPathPara) {
    state.trafficPathPara = trafficPathPara;
  },
  setQueryInverseGeocoder(state, inverseGeocoderPara) {
    state.inverseGeocoderPara = inverseGeocoderPara;
  },
  setStartPara(state, startPara) {
    state.startPara = startPara;
  },
  setEndPara(state, endPara) {
    state.endPara = endPara;
  },
  setTrafficStation(state, trafficStation) {
    state.trafficStation = trafficStation;
  }
};

export default {
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/query.js